import TrustPageTabs from '@/components/Trust/TrustPageTabs';

export default function TrustRoute() {
  return <TrustPageTabs />;
}
